<template>
  <!-- 我要申报（申请成为申报人） -->
  <div class="page">
    <van-nav-bar
      title=""
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
    />

    <img class="pa-top" v-if="banner.imagePath" :src="banner.imagePath | qiniuImageView(1, 710, 314)" />
    <div class="info-box">
      <div class="title">填写资料</div>
      <div class="form-box">
        <van-form>
          <div class="flex-box">
            <span class="label">单位名称</span>
            <!-- <van-field
              v-model="formData.companyName"
              name="公司名称"
              placeholder="请输入公司名称"
              :rules="[{ required: true,}]"
            > -->
            <van-field
            style="border:1px solid #ccc;height: 40px;border-radius: 10px;line-height: 20px;"
              v-model="formData.companyName"
              name="单位名称"
              placeholder="请输入单位名称"
              :rules="[{}]"
            >
            </van-field>
          </div>
          <div class="flex-box">
            <span class="label">姓名</span>
            <van-field
            style="border:1px solid #ccc;height: 40px;border-radius: 10px;line-height: 20px;"
              v-model="formData.realname"
              name="姓名"
              placeholder="请输入姓名"
              :rules="[{}]"
            >
            </van-field>
          </div>
          <div class="flex-box">
            <span class="label">手机号</span>
            <!-- <van-field
              v-model="formData.mobileNumber"
              name="手机号"
              placeholder="请输入手机号"
              :rules="[
                {},
                {
                  pattern: new RegExp(/^(?:(?:\+|00)86)?1[3-9]\d{9}$/)
                }
              ]"
              type="tel"
            >
            </van-field> -->
            <van-field
            style="border:1px solid #ccc;height: 40px;border-radius: 10px;line-height: 20px;"
              v-model="formData.mobileNumber"
              name="手机号"
              placeholder="请输入手机号"
              type="tel"
              maxlength=11
              @input="okPhone"
              @blur="okPhone"
            >
            </van-field>
          </div>
          <div class="flex-box-tip" v-if="redPhone">
            请输入正确的手机号
          </div>
          <div class="flex-box">
            <span class="label">身份证</span>
            <!-- <van-field
              v-model="formData.idcardNo"
              name="身份证"
              placeholder="请输入身份证"
              :rules="[
                {},
                { validator: validateIDCard,}
              ]"
            >
            </van-field> -->
            <van-field
            style="border:1px solid #ccc;height: 40px;border-radius: 10px;line-height: 20px;"
              v-model="formData.idcardNo"
              name="身份证"
              placeholder="请输入身份证"
              @input="okidnum"
              @blur="okidnum"
            >
            </van-field>
          </div>
          <div class="flex-box-tip" v-if="redIdNum">
            请输入正确的身份证号
          </div>

          <div class="license">
            <div class="label" style="margin-bottom:21px">上传图片</div>
            <div class="tip">
              请上传图片
            </div>
            <van-field
              name="uploader"
              :rules="[{ message: '上传图片' }]"
              >

              <template #input>
                <van-uploader name="uploader" :max-count="3" :after-read="afterRead" :before-delete="afterDelete" :before-read="beforeRead" :disabled="noCanUp">
                  <div class="img-list" >
                    <div v-show="formData.imgs.length > 0">
                      <div class="img-box" v-for="(image, index) in formData.imgs" :key="index">
                        <img :src="image | qiniuImageView(1, 140, 140)">
                        <div class="img-box-d" @click="afterDelete(index)">x</div>
                      </div>
                    </div>
                    <img style="margin-left:20px" v-show="formData.imgs.length < 3" width="70" height="70" src="../../assets/images/pa-ex.png" alt="" srcset="" />
                  </div>
                  <!-- <template #preview-cover="{ file }" >
                    <div class="preview-cover van-ellipsis">
                      {{ file.name }}
                    </div>
                  </template> -->
                </van-uploader>
              </template>



              <!-- 使用组件渲染，需要base64 -->
              <!-- <template #input>
                <van-uploader name="uploader" v-model="formData.imgs" :max-count="3" :after-read="afterRead" :before-delete="afterDelete" :before-read="beforeRead">
                  <img v-show="formData.imgs.length < 3" width="70" height="70" src="../../assets/images/pa-ex.png" alt="" srcset="" />
                  <template #preview-cover="{ file }" >
                    <div class="preview-cover van-ellipsis">
                      {{ file.name }}
                    </div>
                  </template>
                </van-uploader>
              </template> -->
              <!-- 使用组件渲染，需要base64 -->
            </van-field>
          </div>

          <!-- <div class="license" v-if="this.changeImgs == false">
            <div class="label" style="margin-bottom:21px">上传图片</div>
            <div class="tip">
              已上传图片      <span class="changeBtn" @click="changeImgs = true">修改图片</span>
            </div>
              <div class="img-list">
                  <div class="img-box" v-for="(image, index) in imgs" :key="index">
                      <img v-if="image"  :src="image | qiniuImageView(1, 140, 140)">
                  </div>
              </div>
            </div> -->

          <div style="margin: 16px;">
            <Button round block type="info" native-type="submit" style="background-Color: #FD4A46;border: none;" @click="onSubmit">立即提交</Button>
          </div>

        </van-form>
      </div>
    </div>
  </div>
</template>

<script>
import mix1 from '@/mixins/page'
import { delayAsync } from '@/utils/common'
import { uiShowLoading, uiHideLoading, uiAlert, uiConfirm } from '@/utils/ui'
import {
  Button,
  NumberKeyboard,
  Field,
  DatetimePicker,
  Overlay,
  Form,
  CellGroup,
  Popup,
  Area,
  Switch,
  Uploader,
  Toast,
  NavBar 
} from "vant";
import {
  localStorageGet,
  localStorageSet,
  localStorageRemove
} from "@/utils/storage";
export default {
  name: "homeApplication",
  mixins: [mix1],
  components: {
    Button,
    NumberKeyboard,
    [Switch.name]: Switch,
    [Area.name]: Area,
    [Popup.name]: Popup,
    [Form.name]: Form,
    [CellGroup.name]: CellGroup,
    [Overlay.name]: Overlay,
    [Field.name]: Field,
    [DatetimePicker.name]: DatetimePicker,
    [Button.name]: Button,
    [Uploader.name]: Uploader,
    [NavBar.name]: NavBar
  },
  created(){
    console.log("本地更新了，看看线上是否更新");
    this.getData();
    this.getBanner();
  },
  data() {
    return {
      banner:{},
      // imgs:{},
      // changeImgs:true,
      formData: {
        companyName: "",
        realname:"",
        mobileNumber: "",
        idcardNo: "",
        imgs: [],
      },

      // imgkeys:[],//传图片后拿到的图片key数组,被操作数组
      // imgkeys2:[],//进入页面拿到的图片key数组，不改变就赋值回给操作数组
      // storageImgKeysArr:[],//要缓存到本地的图片数组

      queryId:"",
      redPhone:false,
      redIdNum:false,

      // storageImgArr:[],//传图片后拿到的图片base64数组 被操作数组
      // storageImgArr2:[],//进入页面拿到的缓存到本地的图片数组，不改变就赋值回给操作数组


      noCanUp:false,//是否可以上传文件
    };
  },
  methods: {
    onClickLeft(){
      this.$router.go(-1);
    },
    // 正确的手机号
    okPhone(){
      const reg = /^1[3-9]\d{9}$/;
      // reg.test(this.formData.mobileNumber)
      if(!reg.test(this.formData.mobileNumber)){
        console.log("手机号错");
        this.redPhone = true;
      }else{
        console.log("手机号对");
        this.redPhone = false;
      }
      // return /^(?:(?:\+|00)86)?1[3-9]\d{9}$/.test(
      //   val
      // );
    },
    // 正确身份证
    okidnum(){
      const reg2 = /^[1-9]\d{5}(18|19|20|21|22)?\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}(\d|[Xx])$/;
      if(!reg2.test(this.formData.idcardNo)){
        this.redIdNum = true;
      }else{
        this.redIdNum = false;
      }
    },
    // 获取并修改信息
    async getData(){
        const promise = this.apiGet("declaration.postForm");
        let apiResult = null;
        try {
            apiResult = await promise;
        } catch (ex) {
            apiResult = null;
        }

        console.log("apiResult",apiResult);
        if(apiResult.obj.imgs){
          console.log("存在数据赋值",apiResult.obj);
          this.formData = apiResult.obj;
        }

        this.queryId = this.$route.query.id;
        console.log("是否有id：",this.queryId);
        if(this.queryId != "" && this.queryId != undefined && this.queryId != null){
          console.log("进来了,有id");
        }

        console.log("getData:",this.formData);
    },
    // 获取banner
    async getBanner() {
      let data = {
        type: 6
    };
    uiShowLoading();
    
    const promise = this.apiGet("homepage.banner",data);

      let apiResult = null;

      try {
        apiResult = await promise;
      } catch (ex) {
        console.log("ex：",ex);
        apiResult = null;
      }

      if (this.isEmpty(apiResult)) {
        return;
      }
      console.log("getBanner:",apiResult.obj);

      this.banner = apiResult.obj;
      uiHideLoading();
  
      // console.log("this.bannerList=>",this.bannerList);
      // this.pagination = apiResult.pagination
      // this.isDataLoaded = true
    },
    // 表单提交
    onSubmit(){
      const reg =  /^(?:(?:\+|00)86)?1[3-9]\d{9}$/;
      const reg2 = /^[1-9]\d{5}(18|19|20|21|22)?\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}(\d|[Xx])$/;
      // if(!reg.test(this.formData.mobileNumber)){
      //   alert("请输入正确的手机号");
      //   return
      // }
      
      console.log("触发了提交")

      if(!reg.test(this.formData.mobileNumber)){
        console.log("this.formData.mobileNumber:",this.formData.mobileNumber);
        this.redPhone = true;
        return
      }
      
      if(!reg2.test(this.formData.idcardNo)){
        console.log("this.formData.idcardNo:",this.formData.idcardNo);
        this.redIdNum = true;
        return
      }

      console.log(this.formData)

      let data = {}
      data.companyName = this.formData.companyName
      data.realname = this.formData.realname
      data.mobileNumber = this.formData.mobileNumber
      data.idcardNo = this.formData.idcardNo

      data.imgs = JSON.stringify(this.formData.imgs)

      if(this.queryId == "" || this.queryId == undefined || this.queryId == null){
        console.log("无id情况，首次提交");

        // let imgjson = JSON.stringify(this.imgkeys);
        // data.imgs = imgjson;

        // this.storageImgKeysArr = this.imgkeys;
        // localStorageSet("storageImgArr",this.storageImgArr)
        // localStorageSet("storageImgKeysArr",this.imgkeys)
         this.postdata(data)
      }else{
        console.log("进入putdata");
        // if(this.imgkeys.length == 0){
        //   this.imgkeys == this.imgkeys.concat(this.imgkeys2);
        // }

        // let imgjson = JSON.stringify(this.imgkeys);
        // data.imgs = imgjson;

        // if(this.storageImgArr.length == 0){
        //   this.storageImgArr = this.storageImgArr2
        // }
        // 存base64图片数组到本地
        // localStorageSet("storageImgArr",this.storageImgArr)
        // 存要上传的图片key数组到本地
        // this.storageImgKeysArr = this.imgkeys;
        // localStorageSet("storageImgKeysArr",this.imgkeys)

        this.putdata(data)
      }
      
    },

    async postdata(data){
      const promise = this.apiPost("declaration.postForm",data);
        let apiResult = null;
        try {
            apiResult = await promise;
        } catch (ex) {
            apiResult = null;
        }
        if (this.isEmpty(apiResult)) {
            return;
        }
        console.log("postdata",apiResult);
        this.$router.push('/home/AddOk');
    },

    async putdata(data){
      console.log("进入put");
      let id = this.$route.query.id;

      const promise = this.apiPut("declaration.postForm.put",{ id: id },data);
        let apiResult = null;
        try {
            apiResult = await promise;
        } catch (ex) {
            apiResult = null;
        }
        if (this.isEmpty(apiResult)) {
            return;
        }
        console.log("putdata",apiResult);
        console.log("tipx",apiResult.obj.msg);
        let tipx = apiResult.obj.msg;
       
        if(apiResult){
          Toast.loading({
            duration: 1500, // 持续展示 toast
            // forbidClick: true,
            message: tipx,
          });
        }
        await delayAsync(1500)
        this.$router.push('/home/AddOk?id='+id);
    },


    // 身份证校验
    validateIDCard(val) {
      // 简单的身份证号码验证规则
      return /^[1-9]\d{5}(18|19|20|21|22)?\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}(\d|[Xx])$/.test(
        val
      );
    },

        async beforeRead(file){
            console.log('beforeRead', file)
            // console.log('beforeRead', data)
        },
        // afterDelete(...args) {
        //     console.log('afterDelete', args)
        //     let index = args[1].index
        //     // this.imgkeys.splice(index, 1);
        //     // this.storageImgArr.splice(index,1)
        //     this.formData.imgs.splice(index,1)
        //     // console.log("删除后的imgkeys：",this.imgkeys);
        //     // console.log("删除后的storageImgArr:",this.storageImgArr);
        //     console.log("删除后的formData.imgs:",this.formData.imgs);
        //     // return true
        // },



        afterDelete(x) {
            console.log('x', x)
            let index = x
            // this.imgkeys.splice(index, 1);
            // this.storageImgArr.splice(index,1)
            this.formData.imgs.splice(index,1)
            // console.log("删除后的imgkeys：",this.imgkeys);
            // console.log("删除后的storageImgArr:",this.storageImgArr);
            console.log("删除后的formData.imgs:",this.formData.imgs);
            // return true
            if(this.formData.imgs.length < 3){
              this.noCanUp = false;
            }
        },
        afterRead(...args){
            console.log('afterRead', args)
            let size = 2097152
            if(args[0].size > size){
            this.uiAlert('上传图片不能大于10MB')
            return
            }
            this.upData(args[0].content)
            // return true
        },

        async compressImg (base64, multiple) {
            // 第一个参数就是需要加密的base65，
            // 第二个是压缩系数 0-1，
            // 第三个压缩后的回调 用来获取处理后的 base64
            if (!base64) {
                return
            }
            const _this = this
            const length = base64.length / 1024
            // 压缩方法
            let newImage = new Image()
            let quality = 0.9   // 压缩系数0-1之间
            newImage.src = base64
            newImage.setAttribute('crossOrigin', 'Anonymous') // url为外域时需要
            let imgWidth,
            imgHeight
            let w = undefined
            newImage.onload = function () {
                // 这里面的 this 指向 newImage
                // 通过改变图片宽高来实现压缩
                w = this.width * multiple
                imgWidth = this.width
                imgHeight = this.height
                let canvas = document.createElement('canvas')
                let ctx = canvas.getContext('2d')
                if (Math.max(imgWidth, imgHeight) > w) {
                if (imgWidth > imgHeight) {
                    canvas.width = w
                    // 等比例缩小
                    canvas.height = w * (imgHeight / imgWidth)
                } else {
                    canvas.height = w
                    // 等比例缩小
                    canvas.width = w * (imgWidth / imgHeight)
                }
                } else {
                canvas.width = imgWidth
                canvas.height = imgHeight
                // quality 设置转换为base64编码后图片的质量，取值范围为0-1  没什么压缩效果
                // 还是得通过设置 canvas 的宽高来压缩
                quality = 0.8
                }
                ctx.clearRect(0, 0, canvas.width, canvas.height)
                ctx.drawImage(this, 0, 0, canvas.width, canvas.height) //  // 这里面的 this 指向 newImage
                let smallBase64 = canvas.toDataURL('image/jpeg', quality) // 压缩语句
                // 如想确保图片压缩到自己想要的尺寸,如要求在50-150kb之间，请加以下语句，quality初始值根据情况自定
                // while (smallBase64.length / 1024 > 150) {
                // quality -= 0.01;
                // smallBase64 = canvas.toDataURL("image/jpeg", quality);
                // }
                // 防止最后一次压缩低于最低尺寸，只要quality递减合理，无需考虑
                // while (smallBase64.length / 1024 < 50) {
                // quality += 0.001;
                // smallBase64 = canvas.toDataURL("image/jpeg", quality);
                // }

                // 必须通过回调函数返回，否则无法及时拿到该值，回调函数异步执行
                console.log(`压缩前：${length}KB`)
                console.log(`压缩后：${smallBase64.length / 1024} KB`)
                console.log('smallBase64', smallBase64)
                _this.upData(smallBase64)
            }
        },

        async upData(smallBase64){
          console.log("smallBase64:",smallBase64);
            let content = smallBase64.split(',').splice(1, 1)
            console.log("处理好的base64:",content);
            if(this.isEmpty(content[0])){
              console.log("base64是空，进入这个提示");
                Toast('上传图片失败')
                return
            }
            uiShowLoading()
            await delayAsync(500)
            const promise = this.apiPost('image.save', {base64: content[0]})
            let apiResult = null
            try {
                apiResult = await promise
            } catch (ex) {
                apiResult = null
            }
            uiHideLoading()
            if (this.hasException(apiResult)) {
                return
            } 
            console.log("图片上传后的返回结果:",apiResult)

            this.formData.imgs.push(apiResult.obj.resourceKey)
            console.log("改动formData.imgs:",this.formData.imgs);

            if(this.formData.imgs.length == 3){
              this.noCanUp = true;
            }

            // this.afterReadArr.push({content:smallBase64});
            // console.log("this.afterReadArr:",this.afterReadArr);

            // console.log("当前图片数组：",this.formData.imgs);

            // this.storageImgArr.push({content:smallBase64});
            // console.log("当前要缓存的图片数组：",this.storageImgArr);

            // this.imgkeys.push(apiResult.obj.resourceKey)
            // console.log("this.imgkeys",this.imgkeys);
        }

  }
};
</script>

<style lang="less" scoped>
.page {
  padding: 0px 20px 36px;
  .pa-top {
    width: 100%;
    height: 314px;
    padding-top: 20px;
    border-radius: 15px;
  }
  .info-box {
    margin-top: 16px;
    background-color: #fff;
    .title {
      text-align: center;
      font-weight: bold;
      font-size: 20px;
      color: #38251e;
      line-height: 31px;
      padding-top: 16px;
      padding-bottom: 29px;
    }
  }
  .flex-box {
    display: flex;
    align-items: center;
    margin-bottom: 40px;
    .label {
      display: block;
      width: 200px;
      text-align: left;
      font-size: 30rpx;
      color: #000000;
    }
  }
  .preview-cover {
    position: absolute;
    bottom: 0;
    box-sizing: border-box;
    width: 100%;
    padding: 4px;
    color: #fff;
    font-size: 12px;
    text-align: center;
    background: rgba(0, 0, 0, 0.3);
  }
  .license {
    width: 710px;
    // padding-left: 10px;
    .label {
      font-size: 30rpx;
      color: #000000;
    }
    .tip {
      font-size: 22rpx;
      color: #c8c8c8;
      padding-top: 21px;
      padding-bottom: 18px;
      display: flex;
      justify-content: space-between;

      .changeBtn{
        display: inline-block;
        color: #fd4a46;
      }
    }

    .img-list{
          width: 750px;
          margin-top:20px;
          display: flex;
          .img-box{
              border: 1px solid #ccc;
              width: 140px;
              height: 140px;
              margin-left: 20px;
              display: inline-block;
              position: relative;
              img{
                  width: 140px;
                  height: 140px;
                }
              .img-box-d{
                // border: 1px solid red;
                width: 30px;
                height: 30px;
                text-align: center;
                line-height: 30px;
                background-color:rgba(0, 0, 0, 0.3);
                position: absolute;
                top: 0;
                right: 0;
                color: #fff;
                z-index: 99999;
              }
              
          }
      }




    img {
      cursor: pointer;
    }
  }

  .flex-box-tip{
    margin-left: 180px;
    font-size: 12px;
    color: #FF0B0B ;
    transform: translateY(-26px);
  }
}
</style>
